<div class="banner-container">
	<div class="heading"><i class="bi bi-envelope"></i></div>
	<div class="action-text">You have been invited to join {{ organisationInvitation.organisation.companyName }}</div>
	<div class="action-buttons">
		<button type="button" class="btn btn-outline-danger" (click)="rejectInvitation()">Reject</button>
		<button type="button" class="btn btn-primary" (click)="acceptInvitation()">Accept</button>
	</div>
</div>
